var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxContained(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 5.78316C16.75 6.23316 16.5083 6.64146 16.125 6.8498L14.675 7.63313L13.4417 8.2915L10.8833 9.67481C10.6083 9.82481 10.3083 9.89983 10 9.89983C9.69166 9.89983 9.39167 9.82481 9.11667 9.67481L3.87499 6.8498C3.49166 6.64146 3.24999 6.23316 3.24999 5.78316C3.24999 5.33316 3.49166 4.9248 3.87499 4.71647L5.51666 3.83313L6.825 3.12482L9.11667 1.8915C9.66667 1.5915 10.3333 1.5915 10.8833 1.8915L16.125 4.71647C16.5083 4.9248 16.75 5.33316 16.75 5.78316Z",
    fill: "#CCCFD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 10.6585L3.37499 8.21682C2.99999 8.02515 2.56666 8.05015 2.20833 8.26682C1.85 8.48348 1.64167 8.86684 1.64167 9.28351V13.8918C1.64167 14.6918 2.08332 15.4085 2.79999 15.7668L7.675 18.2002C7.84166 18.2835 8.02501 18.3252 8.20834 18.3252C8.42501 18.3252 8.64167 18.2668 8.83334 18.1418C9.19167 17.9252 9.4 17.5418 9.4 17.1252V12.5168C9.40833 11.7335 8.96666 11.0168 8.25 10.6585Z",
    fill: "#CCCFD6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3583 9.29172V13.9C18.3583 14.6917 17.9167 15.4083 17.2 15.7667L12.325 18.2083C12.1583 18.2917 11.975 18.3334 11.7917 18.3334C11.575 18.3334 11.3583 18.2751 11.1583 18.1501C10.8083 17.9334 10.5917 17.55 10.5917 17.1334V12.5333C10.5917 11.7333 11.0333 11.0167 11.75 10.6583L13.5417 9.76667L14.7917 9.14167L16.625 8.22502C17 8.03336 17.4333 8.05002 17.7917 8.27502C18.1417 8.49169 18.3583 8.87505 18.3583 9.29172Z",
    fill: "#CCCFD6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.675 7.63331L13.4417 8.29168L5.51666 3.83331L6.825 3.125L14.475 7.44166C14.5583 7.49166 14.625 7.55831 14.675 7.63331Z",
    fill: "#838B9B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7917 9.1416V11.0333C14.7917 11.375 14.5083 11.6583 14.1667 11.6583C13.825 11.6583 13.5417 11.375 13.5417 11.0333V9.7666L14.7917 9.1416Z",
    fill: "#838B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxContained);
export default __webpack_public_path__ + "static/media/box-contained.56f2a9a46c29c2fa03409f7f96c9e166.svg";
export { ForwardRef as ReactComponent };